import React, { memo } from 'react'
import { useField } from 'react-final-form'
import { required } from 'forms/validators'
import { DeliveryTypeEnum } from 'modules/deliveryInfo/types'
import { TScheduleDay } from 'modules/terminal/types'

import { TOrderCreatePoint } from '../../types'
import { OrderCreateFormDate } from '../OrderCreate/OrderCreateFormDate'

type TProps = {
  departureTerminalId: string
  departureTerminalSchedule: TScheduleDay[] | undefined
  departureType: DeliveryTypeEnum | undefined
  destinationTerminalId: string
  destinationTerminalSchedule: TScheduleDay[] | undefined
  destinationType: DeliveryTypeEnum | undefined
}

export const FieldOrderGuestDateBlockForm = memo(function FieldOrderGuestDateBlockForm({
  departureTerminalId,
  destinationTerminalId,
  departureType,
  destinationType,
  departureTerminalSchedule,
  destinationTerminalSchedule
}: TProps) {
  const {
    input: { value: departureDateValue, onChange },
    meta
  } = useField<string>('departureDate', {
    validate: required
  })
  const {
    input: { value: departureValue }
  } = useField<TOrderCreatePoint>('departurePoint')
  const {
    input: { value: destinationValue }
  } = useField<TOrderCreatePoint>('destinationPoint')

  const isSubmitFailed = meta.submitFailed && meta.touched

  const errorDate = (isGuest?: boolean) => {
    if (isSubmitFailed && !departureDateValue.length) {
      return 'Обязательное поле'
    }

    if (isGuest) {
      return 'В указанную дату забор груза невозможен'
    }
  }

  const setError = (isGuest: boolean) => {
    if (isGuest) {
      errorDate(true)
    }
  }

  const clearErrors = () => {}

  return (
    <div>
      <OrderCreateFormDate
        isGuest
        clearErrors={clearErrors}
        departureTerminalId={departureTerminalId}
        departureTerminalSchedule={departureTerminalSchedule}
        departureType={departureType}
        destinationTerminalId={destinationTerminalId}
        destinationTerminalSchedule={destinationTerminalSchedule}
        destinationType={destinationType}
        error={errorDate()}
        onChange={onChange}
        setError={setError}
        value={departureDateValue}
        departureSelectedOption={{
          latitude: departureValue.addressDetail?.latitude,
          longitude: departureValue.addressDetail?.longitude
        }}
        destinationSelectedOption={{
          latitude: destinationValue.addressDetail?.latitude,
          longitude: destinationValue.addressDetail?.longitude
        }}
      />
    </div>
  )
})
